import React from 'react';

//import eftForm from '../assets/forms/eft-form.pdf';
import eftForm from '../../assets/forms/central health eft form.docx';
import priorAuthForm from '../../assets/forms/central health prior authorization form 2024.pdf';
//import providerInfoForm from '../../assets/forms/provider-info-change-form.pdf';
//import appealForm from '../../assets/forms/claim-appeal-form.pdf';

const forms = [
  {
    id: 1,
    title: 'EFT Form',
    description: 'Electronic Funds Transfer enrollment form',
    icon: '\u{1F3E6}',
        iconClass: '',
        file: eftForm
  },
  {
    id: 2,
    title: 'Prior Authorization Form',
    description: 'Request prior approval for services',
    icon: '\u{1F4DD}',
      iconClass: 'green',
      file: priorAuthForm
  },
  //{
  //  id: 3,
  //  title: 'Provider Information Change Form',
  //  description: 'Update your provider information',
  //  icon: '\u{1F4CB}',
  //  iconClass: 'blue',
  //},
  //{
  //  id: 4,
  //  title: 'Claim Reconsideration/ Appeal Request Form',
  //  description: 'Submit an appeal for a denied claim',
  //  icon: '\u{1F4E8}',
  //  iconClass: 'orange',
  //},
];

const FormsPage = () => {
  //const handleDownload = (formTitle) => {
  //  alert(`Downloading ${formTitle}... (demo only)`);
    //};


    const handleDownload = (file, title) => {
        const link = document.createElement('a');
        link.href = file;
        let ext = file.split('.').pop().split('?')[0];
        //link.download = `${title}.docx`;
        link.download = `${title}.${ext}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h1>Forms & Downloads</h1>
          <p>Download commonly used forms for claims, authorizations, and provider updates</p>
        </div>
      </div>

      {/* Forms Grid */}
      <div className="tools-grid" style={{ marginBottom: 28 }}>
        {forms.map((form) => (
          <div
            className="tool-card"
            key={form.id}
            style={{ cursor: 'default', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <div className={`tool-icon ${form.iconClass}`}>{form.icon}</div>
            <h3>{form.title}</h3>
            <p>{form.description}</p>
            <div style={{ marginTop: 'auto', paddingTop: 16, width: '100%' }}>
              <button
                className="btn-primary"
                style={{ width: '100%' }}
                        //onClick={() => handleDownload(form.title)}
                        onClick={() =>
                            handleDownload(form.file, form.title)
                        }
              >
                Download
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Pre-Auth Form Section */}
      {/*<div*/}
      {/*  className="card"*/}
      {/*  style={{*/}
      {/*    background: 'linear-gradient(135deg, rgba(13,148,136,0.06), rgba(15,118,110,0.03))',*/}
      {/*    borderLeft: '4px solid #0D9488',*/}
      {/*    display: 'flex',*/}
      {/*    flexDirection: 'column',*/}
      {/*    gap: 12,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#134E4A' }}>*/}
      {/*    Central Health's Pre-Auth Form*/}
      {/*  </h3>*/}
      {/*  <p style={{ margin: 0, fontSize: 14, color: '#6B7280', lineHeight: 1.6 }}>*/}
      {/*    Complete the pre-authorization form to request prior approval for services.*/}
      {/*  </p>*/}
      {/*  <div>*/}
      {/*    <button*/}
      {/*      className="btn-primary"*/}
      {/*      onClick={() =>*/}
      {/*        alert('Opening Central Health\'s Pre-Auth Form... (demo only)')*/}
      {/*      }*/}
      {/*    >*/}
      {/*      Open Central Health's Form*/}
      {/*    </button>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/* Info Callout */}
      <div
        className="card"
        style={{
          background: 'rgba(13, 148, 136, 0.05)',
          borderLeft: '4px solid #0D9488',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <span style={{ fontSize: 20 }}>i</span>
        <p style={{ margin: 0, fontSize: 14, color: '#134E4A' }}>
          All forms are in PDF and DOCX format. Contact provider support if you need assistance
          completing any form.
        </p>
      </div>
    </div>
  );
};

export default FormsPage;
